import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { usePromiseTracker } from 'react-promise-tracker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BasketContext } from "../src/Business/Context/BasketContext.js";
import BasketShow from "../src/Business/Basket/BasketShow.js";
const WaitingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    promiseInProgress &&
    <div className="text-center WaitMessage  text-success bg-white  shadow p-3">
      <img src="../assets/Images/Waiting1.gif" className="w-10p " /> &nbsp;&nbsp;
      لطفاً منتظر بمانید...</div>


  );
}



const Root = () => {
  // ✅ اینجا useState و useRef درست استفاده شدند
  const [count, setCount] = React.useState(0);
  const [TotalPrice, setTotalPrice] = React.useState(0);
  const [BasketItemList, setBasketItemList] = React.useState([]);
  const basketRef = React.useRef(null);

  return (
    <BasketContext.Provider value={{ count, setCount, TotalPrice, setTotalPrice, BasketItemList, setBasketItemList, basketRef }}>
      <div className='Container'>
        <BasketShow ref={basketRef} className="hide" />
        <App />
        <WaitingIndicator />
      </div>
    </BasketContext.Provider >
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

